module.exports = __webpack_public_path__ + "static/media/grin-squint-tears.4083d5dd.svg";